import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import utils from "../../../utils/utils";
import BodySeparator from "../../../components/customComp/BodySeparator";
import SiteList from "./SiteList";

const SitesBody = (props) => {
  const { sitesData, addTab, handleDropDownChange } = props;

  return (
    <div className="flex-col flex w-full h-full max-h-[85%] mt-10 overflow-hidden">
      <div className="listLabels text-white font-Inter opacity-50 text-[13px] font-normal flex">
        <div className="ml-[30px] w-Site_name">HCP Name</div>
        <div className="w-siteEmail">Contact Person</div>
        <div className="w-siteEmail">Email Address</div>
        <div className="w-sitePhone">Phone Number</div>
        <div className="w-siteStatus">Status</div>
      </div>

      <SiteList
        sitesData={sitesData}
        handleDropDownChange={handleDropDownChange} // Pass directly
        onRowClick={(index) => props.onRowClick(index)}
        onOpenSiteInfo={(index) => props.onOpenSiteInfo(index)}
      />
    </div>
  );
};

export default SitesBody;
